import { userAPI } from '@/apis';
import { useAdvertiserMetaStore } from '@/store/advertiserMeta';
import { storage } from '@/plugins/ionic-storage';
import { cloneDeep } from 'lodash';
import { defineStore } from 'pinia';
import { computed, reactive, ref } from 'vue';
export interface TUserVO {
  /**
   * 头像URL
   */
  avatarUrl?: string;
  /**
   * 黑名单列表及拉黑时间
   */
  blacklist?: string;
  /**
   * 联系信息
   */
  contactInfo?: string;
  /**
   * 创建时间
   */
  createTime?: string;
  /**
   * 通告报名免打扰设置及时间段
   */
  doNotDisturb?: string;
  email?: string;
  /**
   * 昵称
   */
  nickname?: string;
  password?: string;
  /**
   * 收款码
   */
  paymentCode?: string;
  /**
   * 电话号码
   */
  phone?: string;
  /**
   * 用户角色类型（1: 博主, 2: 通告主）
   */
  roleType?: number;
  /**
   * 用户状态（1: 正常, 0: 禁用）
   */
  status?: number;
  /**
   * 最后更新时间
   */
  updateTime?: string;
  /**
   * 用户唯一标识
   */
  userId?: number;
  [property: string]: any;
}

export interface TUserData {
  name?: string;
  avatar?: string;
  vipType?: number;
  type: number;
  userId: string;
  loginType?: ELoginType;
  phone?: string;
  email?: string;
  [property: string]: any;
}
export const enum ELoginType {
  GOOGLE = 'google', // google 登录
  EMAIL = 'email', // 邮箱登录
  PHONE = 'phone', // 手机号登录
  YOUKE = '', // 微信登录
}
export enum EUserType {
  YK = 0, // 游客
  BZ = 1, // 博主
  TGZ = 2, // 通告主
}
export const BZ = 1;
export const TGZ = 2;
export const YK = 0; // 游客
export const useUserStore = defineStore('user', () => {
  const user22 = reactive<TUserData>({
    name: '游客用户',
    avatar:
      'https://lh3.googleusercontent.com/a/ACg8ocLa1TkWi7dEA4KT552BK3Tety2HflAzIC9dg8z5emBMN2wR=s96-c',
    vipType: 0,
    type: EUserType.BZ,
    userId: '63578468959',
    loginType: ELoginType.GOOGLE,
    phone: '13812345678',
  });

  const user = reactive<TUserData>({
    name: '',
    avatar: '',
    vipType: 0, // 0 游客 1 普通用户 2  1级博主 3  2级博主  4  1级通告主 5 2级通告主
    type: 0, // 1 博主 2 通告主, 0 游客、
    userId: '', // 用户id
    loginType: ELoginType.YOUKE, // 0 游客、 1 google 2 邮箱 3 手机号
    email: '',
    // messageCount: null, // 消息数量
  });

  const messageCount = reactive({
    announcement: 0, // 通告审核
    audit: 0, // 审核消息
    follow: 0, // 关注收藏
    plaza: 0, // 广场消息
    system: 0, // 管理员通知
    total: 0, // 总消息
  });

  const initialUser = async () => {
    const userStr = await storage.get('user');
    if (userStr) {
      return JSON.parse(userStr);
    }
  };

  const setUser = async (data: TUserData | TUserVO) => {
    data = cloneDeep(data);

    data.name = data.nickname;
    data.avatar = data.avatarUrl;
    data.type = data.roleType;

    for (const key in data) {
      user[key] = data[key];
    }
    await storage.set('user', JSON.stringify(user));
  };

  const setUserType = async (type: EUserType) => {
    user.type = type;
    await storage.set('user', JSON.stringify(user));
  };

  // 同步用户信息，从本地存储中获取
  const syncUser = async () => {
    const data = await initialUser();
    for (const key in data) {
      user[key] = data[key];
    }
  };

  const clearUser = async () => {
    for (let k in user) {
      delete user[k];
    }
    user.vipType = 0;
    user.type = EUserType.YK;
    await storage.set('user', JSON.stringify(user));
    useAdvertiserMetaStore().invalidate();
  };

  const setMessageCount = (payload: object) => {
    // user.messageCount = playload;
    Object.assign(messageCount, payload);
  };

  type TMessageCountRes = {
    totalCount?: number;
    chatCount?: number;
    auditTotal?: number;
    announcementTotal?: number;
    follow?: number;
    system?: number;
    other?: number;
  };

  /** 仅请求一次未读数并写入 store（列表已读后调用，同步 Tab / 徽标） */
  const refreshMessageCount = () => {
    return userAPI.getMessageCount().then((res: TMessageCountRes) => {
      const totalCount = res?.totalCount ?? 0;
      const chatCount = res?.chatCount ?? 0;
      const auditTotal = res?.auditTotal ?? 0;
      const announcementTotal = res?.announcementTotal ?? 0;
      const follow = res?.follow ?? 0;
      const system = res?.system ?? 0;
      setMessageCount({
        announcement: announcementTotal,
        audit: auditTotal,
        follow,
        plaza: chatCount,
        system,
        total: totalCount,
      });
    });
  };

  let timer: any = null;
  const getUnreadMsgCount = () => {
    clearTimeout(timer);
    timer = null;
    refreshMessageCount().finally(() => {
      timer = setTimeout(getUnreadMsgCount, 5000); // 每5秒刷新一次
    });
  };
  const clearMessageTimer = () => {
    clearTimeout(timer);
    timer = null;
  };
  const mainColor = computed(() => {
    return '#22BBB3'; // user.type === EUserType.TGZ ? '#FFA500' : '#d51b1b';
  });

  // syncUser();

  return {
    user,
    messageCount,
    setUser,
    syncUser,
    clearUser,
    setUserType,
    mainColor,
    setMessageCount,
    refreshMessageCount,
    getUnreadMsgCount,
    clearMessageTimer,
  };
});

export { useTokenStore } from './token';
